import { FormFields } from ".";

export const APPLICATION_DETAILS: FormFields = {
  fields: [
    {
      name: "id",
      label: "Application No.",
      type: "text",
      validationRules: {
        required: "Application No. is required.",
      },
    },
    // Always keep this at second index as we are using this field details on create application model
    {
      name: "productType",
      label: "Product Type",
      type: "select",
      options: ["Personal loan", "Business Loan", "Consumer durables loan"],
      validationRules: {
        required: "Product Type is required.",
      },
    },
  ],
};
